module.exports = __webpack_public_path__ + "img/uploaddemo-1-b.3cb26190.png";